export default "__VITE_PUBLIC_ASSET__fd6d03ff__"